import { Phone, Mail, MapPin, ArrowUp } from 'lucide-react'

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-4">
              <img
                src="/logo-transparent.png"
                alt="Emeralds Cuts"
                className="h-14 object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Precision Care. Pristine Results. Professional lawn care in Jacksonville, FL.
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center justify-center md:justify-start gap-2">
                <Phone className="w-4 h-4 text-[#4caf50]" />
                (904) 293-0005
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2">
                <Mail className="w-4 h-4 text-[#4caf50]" />
                hello@emeraldscuts.com
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2">
                <MapPin className="w-4 h-4 text-[#4caf50]" />
                Jacksonville, FL
              </div>
            </div>
          </div>

          {/* Links */}
          <div className="text-center">
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#services" className="hover:text-[#4caf50] transition-colors">Lawn Mowing</a></li>
              <li><a href="#services" className="hover:text-[#4caf50] transition-colors">Fertilization</a></li>
              <li><a href="#services" className="hover:text-[#4caf50] transition-colors">Landscaping</a></li>
              <li><a href="#services" className="hover:text-[#4caf50] transition-colors">Tree Care</a></li>
            </ul>
          </div>

          <div className="text-center md:text-right">
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-[#4caf50] transition-colors">About Us</a></li>
              <li><a href="#testimonials" className="hover:text-[#4caf50] transition-colors">Reviews</a></li>
              <li><a href="#contact" className="hover:text-[#4caf50] transition-colors">Contact</a></li>
              <li><a href="#booking" className="hover:text-[#4caf50] transition-colors">Book Now</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm text-center sm:text-left">
            © 2026 Emeralds Cuts Lawn Services. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <a href="#" className="hover:text-gray-300">Privacy</a>
            <a href="#" className="hover:text-gray-300">Terms</a>
          </div>
        </div>
      </div>

      {/* Scroll to top */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-10 h-10 bg-[#2d7d32] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#1b5e20] transition-colors z-40"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </footer>
  )
}
